export const Request = () => (
  <svg
    width="19"
    height="22"
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 10C14.7 10 15.37 10.1 16 10.29V9C16 7.9 15.1 7 14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H8.26C7.47 19.87 7 18.49 7 17C7 13.13 10.13 10 14 10ZM4.9 5C4.9 3.29 6.29 1.9 8 1.9C9.71 1.9 11.1 3.29 11.1 5V7H4.9V5Z"
      fill="currentColor"
    />
    <path
      d="M14 12C11.24 12 9 14.24 9 17C9 19.76 11.24 22 14 22C16.76 22 19 19.76 19 17C19 14.24 16.76 12 14 12ZM14 14C14.83 14 15.5 14.67 15.5 15.5C15.5 16.33 14.83 17 14 17C13.17 17 12.5 16.33 12.5 15.5C12.5 14.67 13.17 14 14 14ZM14 20C12.97 20 12.06 19.48 11.52 18.68C12.25 18.26 13.09 18 14 18C14.91 18 15.75 18.26 16.48 18.68C15.94 19.48 15.03 20 14 20Z"
      fill="currentColor"
    />
  </svg>
);
